<template>
  <!-- 区域报备列表 -->
  <div id="reportList" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <!-- 报备编码 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.bbbh') }}：</span>
          <div class="contentCopy">
            <el-input v-model="form.activityCode" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'activityCode')"
            />
          </div>
        </el-col>
        <!-- 活动名称 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.hdmc') }}：</span>
          <div class="contentCopy">
            <el-input v-model="form.activityName" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'activityName')"
            />
          </div>
        </el-col>
        <!-- 申请人 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('newApp.BasicInfo.Applicant') }}：</span>
          <div class="contentCopy">
            <el-input v-model="form.applyUserNameOrId" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'applyUserNameOrId')"
            />
          </div>
        </el-col>
        <!-- 审批状态 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <span class="labelCopy">{{ $t('eventList.AppStatus') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.approvalStatus" clearable :placeholder="$t('general.ps')" @change="searchBtn">
              <el-option
                v-for="item in approvalStatusList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldKey"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 对应销售 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="labelCopy">{{ $t('newApp.BasicInfo.cs') }}：</span>
          <div class="contentCopy">
            <el-input v-model="form.salerNameOrId" :placeholder="$t('general.pec')"
                      @input="inputBoxFilter($event, 'salerNameOrId')"
            />
          </div>
        </el-col>
        <!-- 申请部门 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="labelCopy">{{ $t('eventList.AppDepa') }}：</span>
          <div class="contentCopy">
            <el-select
              v-model="form.applyUserDeptNameOrCode" filterable remote clearable reserve-keyword
              :placeholder="$t('general.peak')"
              :remote-method="getApplyDeptList"
              :loading="applyLoading"
            >
              <el-option
                v-for="item in applyDeptList"
                :key="item.userId"
                :label="item.deptName"
                :value="item.deptCode"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 费用归属部门 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="labelCopy">{{ $t('newApp.Attribute.cad') }}：</span>
          <div class="contentCopy">
            <el-select
              v-model="form.expenseDeptNameOrCode" filterable remote clearable reserve-keyword

              :placeholder="$t('general.peak')"
              :remote-method="getCostDeptList"
              :loading="applyLoading"
            >
              <el-option
                v-for="item in costDeptList"
                :key="item.userId"
                :label="item.deptName"
                :value="item.deptCode"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 费用类型 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <!-- <div class="label">{{ $t('newApp.Attribute.toe') }}</div> -->
          <span class="labelCopy">{{ $t('newApp.Attribute.toe') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.expenseTypeCode" :placeholder="$t('general.ps')" clearable>
              <el-option
                v-for="item in expenseTypeList"
                :key="item.expenseTypeCode"
                :label="item.expenseTypeName"
                :value="item.expenseTypeCode"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 营销形式 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <span class="labelCopy">{{ $t('industryReport.hybblb.cxtj.yxfs') }}：</span>
          <div class="contentCopy">
            <el-select v-model="form.marketingForm" :placeholder="$t('general.ps')" clearable>
              <el-option
                v-for="item in marketingFormsList"
                :key="item.val"
                :label="item.label"
                :value="item.val"
              />
            </el-select>
          </div>
        </el-col>
        <!-- 报备时间 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="labelCopy">{{ $t('newApp.Attribute.bat') }}：</div>
          <div class="contentCopy">
            <el-date-picker
              v-model="form.applyTimeRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :start-placeholder="$t('general.StartTime')"
              :end-placeholder="$t('general.EndTime')"
              @change="handleApplyTimeChange"
            />
          </div>
        </el-col>
        <!-- 活动分类 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.coa') }}：</div>
          <div class="contentCopy">
            <el-select
              v-model="form.activityClassification"
              clearable
              :placeholder="$t('general.ps')"
              @change="searchBtn"
            >
              <el-option v-for="item in activityClassificationList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldKey" />
            </el-select>
          </div>
        </el-col>
        <!-- 总部活动 -->
        <!-- <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.headquarterActivityName') }}：</div>
          <div class="contentCopy">
            <el-input v-model="form.hqActivityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col> -->
        <!-- 模板活动 -->
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" v-show="searchOpenFlag">
          <div class="label">{{ $t('newApp.activityInfo.templateActivityName') }}：</div>
          <div class="contentCopy">
            <el-input v-model="form.templateActivityName" :placeholder="$t('general.pec')" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <!-- 重置 -->
          <el-button plain @click="onreset">{{ $t('btn.Reset') }}</el-button>
          <!-- 搜索 -->
          <el-button type="primary" @click="searchBtn">{{ $t('btn.Search') }}</el-button>
        </div>
      </el-row>
      <!-- 高级搜索按钮 -->
      <div class="advancedSearchBtn">
        <span :class="searchOpenFlag ? 'open' : ''" @click="searchOpenFlag = !searchOpenFlag">
          <span>{{ searchOpenFlag ? $t('btn.CollspseS') : $t('btn.AdvancedS') }}</span>
          <i class="iconfont icon-rili4-icon" />
        </span>
      </div>
    </div>
    <!-- bi智能分析平台 -->
    <div class="common_btnBar">
      <el-button type="primary" @click="exportExcel">{{ $t('btn.Export') }}</el-button>
      <el-button type="primary" @click="biJump">{{ $t('eventList.BIFind') }}</el-button>
    </div>
    <commonTable
      ref="reportListTable"
      @handleSelectChange="handleTableSelectChange"
      @handleCheckBoxAll="handleTableCheckAllChange"
    />
    <!-- 审批流程 -->
    <approvalProcessDialog
      :is-report="true"
      :activity-code="currentActivityCode"
      :approval-dialog-visible="approvalDialogVisible" @dialogCloseHandle="approvalCloseHandle"
    />
    <!-- 召回修改 -->
    <quickProceDialog
      :title="quickProceTitle"
      :quick-proce-dialog-visible="quickProceDialogVisible"
      :activity-code="currentActivityCode"
      use-page="industryReportList"
      :approve-status-code="approveStatusCode"
      @dialogCloseHandle="quickProceCloseHandle"
    />
    <!-- 活动评估 -->
    <assessmentDialog
      :activity-code="currentActivityCode"
      :assessment-dialog-visible="assessmentDialogVisible"
      @dialogCloseHandle="assessmentDialogClose" @handlerSuccess="assessmentSuccess"
    />

    <activityLevelDialog
      ref="activityLevelDialog"
      :activity-code="currentActivityCode"
      :activity-level-dialog-visible="activityLevelDialogVisible"
      @dialogCloseHandle="activityLevelDialogClose"
      @handlerSuccess="activityLevelSuccess"
    />

    <productPromotionLeadingDialog
      ref="productPromotionLeadingDialog"
      :activity-code="currentActivityCode"
      :product-promotion-leading-dialog-visible="productPromotionLeadingDialogVisible"
      @dialogCloseHandle="productPromotionLeadingDialogClose"
      @handlerSuccess="productPromotionLeadingSuccess"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
import approvalProcessDialog from './component/activityQuery/approvalProcessDialog';
import quickProceDialog from './component/activityQuery/quickProceDialog';
import assessmentDialog from './component/reportList/assessmentDialog';
import activityLevelDialog from './component/reportList/activityLevelDialog';
import productPromotionLeadingDialog from './component/reportList/productPromotionLeadingDialog';
import { activityQuery } from './service';
import { newApplicationFormApi } from '../newApplicationForm/service';
import { arrayQuery, isNotEmpty } from '@/utils/utils';
export default {
  name: 'IndustryReportList',
  components: {
    commonTable,
    approvalProcessDialog,
    quickProceDialog,
    activityLevelDialog,
    assessmentDialog,
    productPromotionLeadingDialog

  },
  data () {
    return {
      // 营销活动表单列表
      // 营销活动表单列表
      marketingFormsList: [
        {
          label: this.$t('industryReport.hybblb.cxtj.schd'),
          val: '1'
        },
        {
          label: this.$t('industryReport.hybblb.cxtj.szyx'),
          val: '2'
        }
      ],
      // 搜索面板显示标志
      searchOpenFlag: false,
      // 审批弹窗显示标志
      approvalDialogVisible: false,
      // 评估弹窗显示标志
      assessmentDialogVisible: false,
      // 活动等级弹窗显示标志
      activityLevelDialogVisible: false,
      // 产品推广牵头部门弹窗显示标志
      productPromotionLeadingDialogVisible: false,
      // 表单数据
      form: {
        activityStatus: 0,
        marketingForm: ''
      },
      // 临时表单数据
      tempForm: {
        activityStatus: 0
      },
      // 活动类型列表
      activityTypeList: [],
      // 申请部门列表
      applyDeptList: [],
      // 费用部门列表
      costDeptList: [],
      // 表格数据
      tableData: [],
      // 费用类型列表
      expenseTypeList: [],
      // 物料状态列表
      materialStatusList: [
        {
          label: this.$t('eventList.Configured'),
          val: '1'
        },
        {
          label: this.$t('eventList.NotCon'),
          val: '0'
        }
      ],
      // 当前活动编码
      currentActivityCode: '',
      // // applyKey: 'all',
      // // expenseKey: 'all',
      // 申请加载状态
      applyLoading: false,
      // 是否为品牌推广
      isBrandPromotion: false,
      // 快速流程弹窗显示标志
      quickProceDialogVisible: false,
      // 快速流程弹窗标题
      quickProceTitle: '',
      // 审批状态列表
      approvalStatusList: [],
      activityClassificationList: [],
      // 活动等级列表
      activityLevelList: [],
      // 当前语言
      lang: localStorage.getItem('lang') || 'zh-CN',
      approveStatusCode: null,
      selectedRows: []
    };
  },
  methods: {
    handleTableSelectChange (payload) {
      this.updateSelectedRows(payload);
    },
    handleTableCheckAllChange (payload) {
      this.updateSelectedRows(payload);
    },
    updateSelectedRows ({ records = [] }) {
      this.selectedRows = [...records];
    },
    handleApplyTimeChange (e) {
      if (e) {
        this.$set(this.form, 'startDate', e[0]);
        this.$set(this.form, 'endDate', e[1]);
      } else {
        this.$delete(this.form, 'startDate');
        this.$delete(this.form, 'endDate');
      }
    },
    exportExcel () {
      if (this.form.applyTimeRange) {
        delete this.form.applyTimeRange;
      }
      // 复制当前表单内容到临时表单
      const params = JSON.parse(JSON.stringify(this.form));
      params.reportType = '1';
      const selectedRows = JSON.parse(JSON.stringify(this.selectedRows));
      if (isNotEmpty(selectedRows)) {
        params.activityCodeList = selectedRows.map(item => item.activityCode);
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t('general.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      activityQuery.exportReportList(params).then((res) => {
        loading.close();
        try {
          const arrayBuffer = res.data;
          const contentDisposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
          let fileName = '报备列表.xlsx';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/i);
            if (fileNameMatch) {
              fileName = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
            }
          }
          const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
          this.$message.success(this.$t('general.ExportSuccess'));
        } catch (e) {
          this.$message.error(this.$t('general.ExportFailure'));
        }
      }).catch(() => {
        loading.close();
        this.$message.error(this.$t('general.ExportFailure'));
      });
    },

/**
* 评估成功处理函数
*
* 当评估成功后，关闭评估对话框，并调用搜索按钮的点击事件
*/
    assessmentSuccess () {
      this.assessmentDialogVisible = false;
      this.searchBtn();
    },
    activityLevelSuccess () {
      this.$refs.activityLevelDialog.openDailg(false);
      this.searchBtn();
    },

    productPromotionLeadingSuccess () {
      this.$refs.productPromotionLeadingDialog.openDailg(false);
      this.searchBtn();
    },

    assessmentHandler (row) {
      this.currentActivityCode = row.activityCode;
      this.assessmentDialogVisible = true;
    },
    activityLevelHandler (row) {
      this.currentActivityCode = row.activityCode;
      this.$refs.activityLevelDialog.openDailg(true, row.activityLevel);
    },

    productPromotionLeadingHandler (row) {
      this.currentActivityCode = row.activityCode;
      this.$refs.productPromotionLeadingDialog.openDailg(true, row.productPromotionLeading);
    },

    assessmentDialogClose () {
      this.assessmentDialogVisible = false;
    },
    activityLevelDialogClose () {
      this.$refs.activityLevelDialog.openDailg(false);
    },
    productPromotionLeadingDialogClose () {
      this.$refs.productPromotionLeadingDialog.openDailg(false);
    },

    biJump () {
      window.open('http://ruijiebi.ruijie.com.cn/webroot/decision?rjl=oa');
    },
    quickProcessingBtn (row, title) {
      this.quickProceTitle = title;
      this.currentActivityCode = row.activityCode;
      this.approveStatusCode = row.approveStatusCode;
      this.quickProceDialogVisible = true;
    },
    quickProceCloseHandle () {
      this.quickProceDialogVisible = false;
    },
    inputBoxFilter (val, key) {
      let numVal = val.replace(/^\s+|\s+$/g, '');
      this.$set(this.form, key, numVal);
    },
    // 搜索申请部门的选中事件
    applyChange () {

    },
    approvalStateBtn (row) {
      this.currentActivityCode = row.activityCode;
      this.approvalDialogVisible = true;
    },
    approvalCloseHandle () {
      this.approvalDialogVisible = false;
    },
/**
* 重置表单方法
*
* 重置表单内容，并调用搜索按钮方法
*/
    onreset () {
      this.form = {
        activityStatus: 0
      };
      this.searchBtn();
    },
    // 搜索事件
    searchBtn () {
      if (this.form.applyTimeRange) {
        delete this.form.applyTimeRange;
      }
      // 复制当前表单内容到临时表单
      this.tempForm = JSON.parse(JSON.stringify(this.form));
      this.tempForm.reportType = '1';
      // 重置分页页码为1
      this.$refs.reportListTable.pageData.pageNum = 1;

      // 调用表格组件的getTableData方法，获取数据
      // 参数包括请求URL和请求参数
          this.$refs.reportListTable.getTableData({
            url: '/report/industryReportPage',
            params: this.tempForm
          });
    },
    detailsJump (row) {
      // 查看报备详情 跳转路由 把报备编码传过去
      // let { userId } = this.$store.state.userInfo.sysUser;
      // fieldKey 100 报备审批中
      // fieldKey 101 报备审批完成
      // fieldKey 102 报备驳回
      // fieldValue 报备召回
      // fieldKey 104 报备撤销
      this.$router.push({
        path: '/regionReportDetails',
        query: {
          activityCode: row.activityCode,
          metaActive: '/regionReportList'
        }
      });
      // if (row.approveStatusCode === 101 && row.applyUserId === userId) {
      //   this.$router.push({
      //     path: '/transferApplication',
      //     query: {
      //       activityCode: row.activityCode,
      //       metaActive: '/reportList'
      //     }
      //   });
      // } else {
      //   this.$router.push({
      //     path: '/regionReportDetails',
      //     query: {
      //       activityCode: row.activityCode,
      //       metaActive: '/regionReportList'
      //     }
      //   });
      // }
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._data('checkboxColumn')
          ._width('60')
          ._fixed('left')
          ._others('checkbox')
      );
      // 报备编码
      tableRow.push(
        new TableColumns()
          ._width('160')
          ._title(this.$t('industryReport.hybblb.cxtj.bbbh'))
          ._fixed('left')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              const routeData = this.$router.resolve({
                path: '/regionReportDetails',
                query: {
                  activityCode: row.activityCode,
                  metaActive: '/regionReportList'
                }
              });
              return (
                <div>
                  <a class="btnText" href={routeData.href} onClick={(e) => { e.preventDefault(); this.detailsJump(row); }}>{row.activityCode}</a>
                </div>
              );
            }
          })
      );
      // 活动名称/营销主题
      tableRow.push(
        new TableColumns()
          ._width('18%')
          ._title(this.$t('industryReport.hybblb.cxtj.hdmc'))
          ._data('activityName')
      );
      // 营销形式
      tableRow.push(
        new TableColumns()
          ._width('14%')
          ._title(this.$t('industryReport.hybblb.cxtj.yxfs'))
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <span>{row.marketingForm === 1 ? this.$t('industryReport.hybblb.cxtj.schd') : this.$t('industryReport.hybblb.cxtj.szyx')}</span>
                </div>
              );
            }
          })
      );
      // 申请人
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('industryReport.hybblb.cxtj.sqr'))
          ._data('applyUserName')
      );
      // 对应销售
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('industryReport.hybblb.cxtj.dyxs'))
          ._data('salerName')
      );
      // 部门
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('industryReport.hybblb.cxtj.bm'))
          ._data('salerDeptName')
      );
      // 报备时间
      tableRow.push(
        new TableColumns()
          ._width('8%')
          ._title(this.$t('industryReport.hybblb.cxtj.bbsj'))
          ._data('applyTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(row.applyTime.replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{date}</span>
              );
            }
          })
      );
      // 营销费用
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('industryReport.hybblb.cxtj.yxfy'))
          ._data('totalCost')
      );
      // 审批状态
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.AppStatus'))
          ._align('left')
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let text = row.approveStatus;
              if (this.form.approvalStatus) {
                text = arrayQuery(this.form.approvalStatus, this.approvalStatusList, 'fieldKey').fieldValue;
              }
              return (
                <div>
                  <el-button type="text" onClick={() => { this.approvalStateBtn(row); }}>{text}</el-button>
                </div>
              );
            }
          })
      );
      // 操作
      tableRow.push(
        new TableColumns()
          ._width('210')
          ._title(this.$t('general.Operation'))
          ._fixed('right')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let userInfo = this.$store.state.userInfo;
              // 召回修改：当费用归属只有一条的时候才可以召回    召回后该活动会保存在草稿里
              // 活动评估：当前登陆人为品牌推广部的才可以进行活动评价
              return (
                <div>
                  <el-button type="text" onClick={() => { this.quickProcessingBtn(row, this.$t('btn.Revoke')); }}>{this.$t('btn.Revoke')}</el-button>
                  <el-button type="text" onClick={() => { this.quickProcessingBtn(row, this.$t('btn.RecallC')); }}>{this.$t('btn.RecallC')}</el-button>
                  {
                    userInfo.sysUser.deptCode.indexOf('000013') === 0 ? (
                      <el-button type="text" onClick={() => { this.assessmentHandler(row); }}>{this.$t('btn.ActivityE')}</el-button>
                    ) : null
                  }
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.reportListTable.setColumn(column, {
        resizable: true
      });
      this.$refs.reportListTable.loadTable({ url: '/report/industryReportPage', listKey: 'list', params: { activityStatus: 0, reportType: '1' } });
    },
    getActivityCommonList () {
      const params = [
        'activity_type',
        'activity_classification',
        'report_approval_status'
      ];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          this.activityTypeList = res.data.activity_type || [];
          this.activityClassificationList = res.data.activity_classification.filter(item => {
              return item.fieldKey !== 'AC_06';
            }) || [];
          this.approvalStatusList = res.data.report_approval_status || [];
        }
      });
    },
    getApplyDeptList (applyKey) {
      if (applyKey && applyKey.indexOf(' ') === 0) {
        this.applyDeptList = [];
        return;
      }
      applyKey = applyKey || 'all';
      let params = {
        type: 'APPLAY',
        key: applyKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.applyDeptList = res.data;
        }
      });
    },
    getCostDeptList (expenseKey) {
      if (expenseKey && expenseKey.indexOf(' ') === 0) {
        this.costDeptList = [];
        return;
      }
      expenseKey = expenseKey || 'all';
      let params = {
        type: 'EXPENSE',
        key: expenseKey
      };
      activityQuery.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.costDeptList = res.data;
        }
      });
    },
    getExpenseTypeList () {
      activityQuery.getExpenseTypeList().then(res => {
        if (res.status === '200') {
          this.expenseTypeList = res.data;
        }
      });
    },
    getActivityLevelList () {
      let params = [
              'activity_level'
            ];
            newApplicationFormApi.getActivityList(params).then(res => {
              if (res.status === '200') {
                this.activityLevelList = res.data.activity_level;
              }
            });
    }
  },
  activated () {
    this.tempForm.reportType = '1';
    this.$refs.reportListTable.getTableData({ url: '/activity/market_activity_list', params: this.tempForm });
  },
  mounted () {
    this.isBrandPromotion = this.$store.state.userInfo.belongToBrandPromotionDept;
    this.loadTable();
    this.getActivityCommonList();
    this.getApplyDeptList();
    this.getCostDeptList();
    this.getExpenseTypeList();
    this.getActivityLevelList();
  }
};
</script>

<style scoped>

</style>
